/**
 * Board Schedule Hooks (subscribe to schedule cache)
 */

import { useSyncExternalStore } from 'react';
import { getScheduleCache, subscribeToScheduleCache } from '../stores/roadmapStore';
import type { ScheduledTask, EmployeeStats, DoubleBookingWarning } from '../../stores/types';

const emptyScheduledTasks = new Map<string, ScheduledTask>();
const emptyEmployeeStats = new Map<string, EmployeeStats>();

function useScheduleCache() {
  return useSyncExternalStore(
    subscribeToScheduleCache,
    getScheduleCache,
    getScheduleCache
  );
}

export function useScheduledTask(taskId: string): ScheduledTask | undefined {
  const cache = useScheduleCache();
  return cache?.scheduledTasks.get(taskId);
}

export function useScheduledTasks(): Map<string, ScheduledTask> {
  const cache = useScheduleCache();
  return cache?.scheduledTasks ?? emptyScheduledTasks;
}

export function useEmployeeStats(): Map<string, EmployeeStats> {
  const cache = useScheduleCache();
  return cache?.employeeStats ?? emptyEmployeeStats;
}

export function useEmployeeStatsById(employeeId: string): EmployeeStats | undefined {
  const cache = useScheduleCache();
  return cache?.employeeStats.get(employeeId);
}

export function useDoubleBookingWarnings(): DoubleBookingWarning[] {
  const cache = useScheduleCache();
  return cache?.doubleBookingWarnings ?? [];
}

export function useIsScheduleReady(): boolean {
  const cache = useScheduleCache();
  return cache !== null;
}
